/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Forward': {
    width: 22,
    height: 17,
    viewBox: '0 0 22 17',
    data: '<path pid="0" d="M8.36 3.088a1.2 1.2 0 011.658-1.736l6.6 6.3a1.2 1.2 0 010 1.736l-6.6 6.3a1.2 1.2 0 11-1.657-1.736l5.69-5.432-5.69-5.432zM18.43 2.22a1.2 1.2 0 112.4 0v12.6a1.2 1.2 0 11-2.4 0V2.22z" _fill="#00204D" _stroke="#00204D" stroke-width=".6" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M2.232 9.754a1.2 1.2 0 110-2.4h11.64a1.2 1.2 0 010 2.4H2.231z" _fill="#00204D" _stroke="#00204D" stroke-width=".6" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
